import {
  APP_ENABLE_NEW_RELIC_ERROR_REPORTING,
  APP_ENABLE_SENTRY_ERROR_REPORTING,
} from '@app/GlobalVariables/constants';
import { getGlobalVariable } from '@app/GlobalVariables/util';
import { ScopeContext } from '@sentry/types/types/scope';
import { IS_LOCAL_DEV, IS_LOCAL_OR_CI_CYPRESS } from '@utils/constants';
import { win } from '@utils/win';
import { reportCustomSentryError } from './sentry';

export const reportCustomError = (
  err: string | Error,
  kwargs?: {
    level?: 'debug' | 'info' | 'warn' | 'error' | 'trace';
  } & Partial<ScopeContext>,
): void => {
  const sendToNewRelic = getGlobalVariable(
    APP_ENABLE_NEW_RELIC_ERROR_REPORTING,
  );
  const sendToSentry = getGlobalVariable(APP_ENABLE_SENTRY_ERROR_REPORTING);

  if (sendToNewRelic) {
    if (IS_LOCAL_DEV || IS_LOCAL_OR_CI_CYPRESS) {
      // eslint-disable-next-line no-console
      console.error('Error sent to New Relic (if allowed):', err);
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (win as anyOk).__mockNewRelicCall?.(err);
      } catch {
        // noop
      }
    }

    win.newrelic?.noticeError(err);
  }

  if (sendToSentry) {
    // Exclude 'level' when sending to Sentry
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { level, ...sentryKwargs } = kwargs ?? {};
    reportCustomSentryError(err, sentryKwargs);
  }
};
